import React, { useEffect, useState } from 'react';

// Startsequenz: 0.0–1.5 s Logo vollflächig, 1.5–2.0 s Überblendung, danach ausgehängt.
// SPLASH_FADE_MS muss zur transition-duration in static/components/splash-screen.css passen.
const SPLASH_VISIBLE_MS = 1500;
const SPLASH_FADE_MS = 500;

/**
 * SplashScreen – vollflächiger Startbildschirm mit zentriertem Logo.
 *
 * Liegt über allem (z-index) und blendet sich nach SPLASH_VISIBLE_MS aus.
 * Nach insgesamt 2.0 s wird onFinished aufgerufen; die aufrufende Komponente
 * nimmt den Splash danach aus dem DOM und gibt die Folgeschritte frei.
 *
 * onFinished sollte stabil sein (useCallback), sonst starten die Timer neu.
 */
const SplashScreen = ({ onFinished }) => {
  const [fading, setFading] = useState(false);

  useEffect(() => {
    const fadeTimer = setTimeout(() => setFading(true), SPLASH_VISIBLE_MS);
    const doneTimer = setTimeout(() => onFinished?.(), SPLASH_VISIBLE_MS + SPLASH_FADE_MS);
    return () => {
      clearTimeout(fadeTimer);
      clearTimeout(doneTimer);
    };
  }, [onFinished]);

  return (
    <div className={`splash-screen${fading ? ' splash-screen--fading' : ''}`} aria-hidden="true">
      <img src="/logo-mobile.svg" className="splash-screen__logo splash-screen__logo--mobile" alt="" />
      <img src="/logo-desktop.svg" className="splash-screen__logo splash-screen__logo--desktop" alt="" />
    </div>
  );
};

export default SplashScreen;
